module.exports = __webpack_public_path__ + "img/43.b4bb8a59.svg";